'use strict';
module.exports = WebSocket;



//////////////////
// WEBPACK FOOTER
// ./~/twilio-client/browser/ws.js
// module id = 30zq
// module chunks = 0